import type { ReactNode } from 'react';

import { Badge } from '~/components/ui/badge';
import { TabsList, TabsTrigger } from '~/components/ui/tabs';

export interface TabBarItem {
  value: string;
  label: ReactNode;
  /** Shown as a badge after the label, e.g. the number of connections. */
  count?: number;
}

interface TabBarProps {
  items: TabBarItem[];
  /** Accessible name for the tab list when no visible heading labels it. */
  'aria-label'?: string;
  className?: string;
}

/**
 * The app's one tab row style: a full-width underlined row that scrolls
 * sideways when its tabs overflow. Render it inside a `<Tabs>` root, which
 * owns the selected value.
 */
export function TabBar({ items, className, ...props }: TabBarProps) {
  return (
    <TabsList variant="line" className={className} {...props}>
      {items.map((item) => (
        <TabsTrigger key={item.value} value={item.value}>
          {item.label}
          {item.count !== undefined && <Badge variant="secondary">{item.count}</Badge>}
        </TabsTrigger>
      ))}
    </TabsList>
  );
}
